import { usePrevious } from "@uidotdev/usehooks";
import { useEffect } from "react";
import usePreference from "./usePreference";
import useProfileBalance from "./useProfileBalance";

/**
 * Hook to automatically refetch balance when websocket reconnects successfully.
 * This ensures balance stays synchronized after reconnection.
 * Should be called once in WSRouteLayout to prevent multiple refetches.
 */
export function useBalanceRefetchOnReconnect() {
  const { isWsConnected } = usePreference();
  const { refetch } = useProfileBalance();
  const prevIsWsConnected = usePrevious(isWsConnected);

  useEffect(() => {
    // Only refetch on reconnection (false -> true transition)
    // Skip initial connection (prevIsWsConnected is null/undefined)
    if (prevIsWsConnected === false && isWsConnected === true) {
      refetch();
    }
  }, [isWsConnected, prevIsWsConnected, refetch]);
}
